import React, {createContext, useContext, useMemo} from 'react';

import type {
    OnCloseAllNote,
    OnCloseNote,
    OnCreateNote,
} from '../typedef';
import type {ComponentType, ReactNode} from 'react';

type ContextType = {
    onCreateNote: OnCreateNote,
    onCloseNote: OnCloseNote,
    onCloseAllNote: OnCloseAllNote,
};

const asyncNoop = async () => await undefined;

const DEFAULT_CONTEXT = {
    onCreateNote: asyncNoop,
    onCloseNote: asyncNoop,
    onCloseAllNote: asyncNoop,
};

const Context = createContext<ContextType>(DEFAULT_CONTEXT);

export const usePushNotificationContext = (): ContextType => useContext<ContextType>(Context);

type Props = {
    children: ReactNode,
} & ContextType;

export const PushNotificationWithContext: ComponentType<Props> = (props: Props) => {
    const {
        onCreateNote,
        onCloseNote,
        onCloseAllNote,
        children,
    } = props;

    const value = useMemo(() => ({
        onCreateNote,
        onCloseNote,
        onCloseAllNote,
    }), [
        onCreateNote,
        onCloseNote,
        onCloseAllNote,
    ]);

    return <Context.Provider value={value}>{children}</Context.Provider>;
};
